import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSelectOption } from '../../hooks';
import { getFormState } from '../../store/app/selectors';
import { SINGLE_WALL, WALL } from '../../utils';
import ConditionalRender from '../common/ConditionalRender';
import { CornerWallForm } from './CornerWallForm';
import { SingleWallForm } from './SingleWallForm';
export const Filter = () => {
    const formState = useSelector(getFormState);
    const selectOption = useSelectOption();
    const [shouldAnimate, setShouldAnimate] = useState(false);
    // Prevent the animation to run on page load, ugly solution
    useEffect(() => {
        setTimeout(() => {
            setShouldAnimate(true);
        }, 500);
    }, []);
    return (_jsx(ConditionalRender, { predicate: !formState.wall || formState[WALL] === SINGLE_WALL, fallback: _jsx(CornerWallForm, { shouldAnimate: shouldAnimate, selectOption: selectOption }), children: _jsx(SingleWallForm, { shouldAnimate: shouldAnimate, selectOption: selectOption }) }));
};
//# sourceMappingURL=Filter.js.map